import { EnvironmentProviders, ErrorHandler, InjectionToken, makeEnvironmentProviders } from "@angular/core";
import { GlobalErrorHandler } from "./error-handler.provider";

export const LOGGER_URL = new InjectionToken<string>("LOGGER_URL");

// The provideLogger function is a factory function that returns an EnvironmentProviders array.
// It sets up the LOGGER_URL injection token with the provided URL and configures the GlobalErrorHandler to handle uncaught errors globally.
// This allows for centralized logging of errors and messages to a specified server endpoint.
export function provideLogger(url: string): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: LOGGER_URL, useValue: url },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
    ]);
}
